module.exports = "/assets/data/7dd682a2dbe7038a2a614d915abc0f92-PR8.data.json";